import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import * as React from "react";
import { cx } from "../internal/cx.js";

export type CheckboxProps = React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>;

/**
 * Single boolean checkbox. Pair with a `<Label htmlFor={id}>` for the
 * accessible name — the checkbox itself does not own its label, so the
 * consumer always provides one.
 */
export const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  CheckboxProps
>(function Checkbox({ className, ...props }, ref) {
  return (
    <CheckboxPrimitive.Root ref={ref} className={cx("cw-v2-checkbox", className)} {...props}>
      <CheckboxPrimitive.Indicator className="cw-v2-checkbox__indicator">
        <svg aria-hidden="true" viewBox="0 0 12 12">
          <title>Checked</title>
          <path
            d="M2.5 6.2L4.8 8.5L9.6 3.5"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
        </svg>
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
});
Checkbox.displayName = "Checkbox";
